// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__24zFE","fileDisabled":"File_fileDisabled__2zcWd"};